import { getDecadeStart } from "@wojtekmaj/date-utils";

import TileGroup from "../TileGroup";
import Decade from "./Decade";

import { getBeginOfCenturyYear } from "../shared/dates";

export default function Decades(props) {
  const {
    activeStartDate,
    hover,
    showNeighboringCentury,
    value,
    valueType,
    ...otherProps
  } = props;
  const start = getBeginOfCenturyYear(activeStartDate);
  const end = start + (showNeighboringCentury ? 119 : 99);

  return (
    <TileGroup
      className="react-calendar__century-view__decades"
      dateTransform={getDecadeStart}
      dateType="decade"
      end={end}
      hover={hover}
      renderTile={({ date, ...otherTileProps }) => (
        <Decade
          key={date.getTime()}
          {...otherProps}
          {...otherTileProps}
          activeStartDate={activeStartDate}
          currentCentury={start}
          date={date}
        />
      )}
      start={start}
      step={10}
      value={value}
      valueType={valueType}
    />
  );
}
